// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"424":"366ccb1a","566":"44bbf03f"}[chunkId] + ".chunk.css";
};